<template lang="html">
  <div class="col-12 col-xl-10 offset-xl-1 col-tab-2">
    <h5 class="tab-title">¿Qué es la portabilidad numérica?</h5>

    <div class="d-block mt-3">
      <h5 class="subtitle">¿Qué es un DN o Número Digital?</h5>
      <p>
        La portabilidad numérica es el derecho que tienes como usuario de telefonía fija o móvil a conservar tu número telefónico cuando decides cambiar de operador.<br />
        ¡Portación en 24 horas! y ¡Es gratuito!<br />
        Tú tienes derecho a una portabilidad efectiva y que la misma se realice en un plazo no mayor a 24 horas contadas a partir de la solicitud realizada por el titular del número a su operador.
      </p>

      <br />
      <h5 class="subtitle">¿Cómo hago la Portabilidad?</h5>
      <p>
        Para realizar una portabilidad numérica un agente comercial realiza el trámite, se espera el tiempo de gracia 24hrs.<br />
        La solicitud de NIP se puede realizar marcando o mandando un mensaje con la palabra NIP al número de teléfono #051, también la solicitud se puede realizar en nuestra página web, (la línea a portar deberá estar vigente y activa)
        http://www.ift.org.mx/usuarios-telefonia-movil/todo-lo-que-debes-saber-sobre-la-portabilidad-numerica.<br />
        <br />
        Al momento de hacer la marcación al 051, el mensaje de texto que se enviará a tú número contendrá la siguiente leyenda: “ESTÁ INICIANDO SU CAMBIO DE EMPRESA DE TELEFONÍA MÓVIL. ENTREGUE LA CLAVE A LA NUEVA EMPRESA SOLO SI DESEA CAMBIARSE. SU NIP DE PORTABILIDAD ES XXXX”
      </p>

      <br />
      <h5 class="subtitle">¿Qué es un NIP?</h5>
      <p>
        El NIP es un Número de Identificación Personal de 4 dígitos que te proporciona la IFT, como el mecanismo de confirmación para validar la voluntad de los usuarios para hacer una portabilidad numérica o cambio de compañía con su mismo número.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es tecnología VoLTE?</h5>
      <p>
        VoLTE significa Voz sobre evolución a largo plazo o Voz sobre LTE. VoLTE ofrece la posibilidad de realizar llamadas de voz a través de la red móvil LTE/4G*.<br />
        Anteriormente, 4G se limitaba a la navegación por Internet. Cuando se trataba de llamadas, el teléfono cambiaba automáticamente a 3G o 2G. Es posible que recuerdes que había unos segundos de demora hasta que el teléfono del destinatario sonaba. Gracias a VoLTE, esa demora ha desaparecido.<br />.
        En una red 2G o 3G, las llamadas y los datos se separan y no pueden funcionar simultáneamente. Por ejemplo, durante una llamada telefónica en una red 2G, los mensajes de texto entrantes en ese momento solo llegarán después de haber finalizado la llamada telefónica. En una red 4G LTE, tanto las llamadas como los datos funcionan al unísono, lo que significa que un mensaje de texto llegará al instante incluso durante una llamada.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es Voz App?</h5>
      <p>
        VozApp es la aplicación de voz que permite utilizar el servicio de telefonía móvil con skycel y Red Compartida en México. Con VozApp puedes hacer y recibir llamadas a través de datos con la mejor calidad en tu Smartphone 4G Android.<br />
        VozApp funciona en equipos 4G compatibles con Banda 28 en México (700MHz). Puedes utilizar un equipo desbloqueado que hayas adquirido de cualquier compañía Telefónica.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es un IMEI?</h5>
      <p>
        El IMEI (del inglés International Mobile Equipment Identity, identidad internacional de equipo móvil) es un código USSD pregrabado en los teléfonos móviles GSM. Este código identifica al aparato de forma exclusiva a nivel mundial, y es transmitido por el aparato a la red al conectarse a esta. Para saber tu IMEI solo basta en tu teclado marcar *#06#.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es una ICCID?</h5>
      <p>
        El ICC o Internacional Circuit Card es un código de 19 dígitos único para cada tarjeta SIM. Este número es algo así como un número de serie que identifica la tarjeta como única a nivel global e internacional.
      </p>

      <br />
      <h5 class="subtitle">¿Que es un R o RR?</h5>
      <p>
        Es un reporte de robo o reporte por incumplimiento de pago, cuando te roban un equipo puedes contactar vía internet con la IFT para reportar tu equipo IMEI que fue robado, seguido a esto se bloquea tu teléfono para que no puedan utilizarlo. Cuando es un reporte por incumplimiento de pago, la empresa donde se adquirió el equipo lo bloquea porque aún existe un compromiso de pago sobre el mismo.<br />
        IFT me lo reportan  robaron por robo http://www.ift.org.mx/usuarios-y-audiencias/consulta-de-imei<br />
        Por empresa: no se puede verificar que está bloqueado.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es el roaming?</h5>
      <p>
        Roaming significa lo mismo que la itinerancia de datos. Este servicio nos permite utilizar nuestro celular (Llamadas, SMS y datos móviles) cuando viajamos fuera de la cobertura de señal que tiene nuestra compañía, esto es posible debido a los acuerdos realizados por nuestra compañía móvil con otros operadores tanto en nuestro país como en el extranjero.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es la Política de Uso Justo?</h5>
      <p>
        La Política de Uso Justo es una regulación en la velocidad de navegación y descarga, los minutos de llamada y cantidad de mensajes SMS que se aplica a los planes y paquetes que cuentan con servicios “ilimitados”, una vez que se llega al límite o umbral de transferencia de información, con la finalidad de evitar la sobresaturación de la red, de tal forma, que todos los Usuarios puedan disfrutar del servicio con una calidad y velocidad promedio estable. Esta regulación no implica ninguna restricción en las comunicaciones ni en el acceso a la información.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es un servicio de Prepago?</h5>
      <p>
        Un plan prepago es un paquete de Internet, minutos o SMS (o de los tres) que es más flexible con el usuario, ya que no depende de un contrato, sino que se adquiere cuando de manera independiente decidimos usar parte de nuestro saldo. En otras palabras, pagamos antes de usar el servicio que necesitemos y que elegimos acorde a nuestra capacidad de pago y necesidades.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es un servicio de Pospago?</h5>
      <p>
        Pospago es un concepto que se utiliza para calificar al servicio de telefonía o de televisión que se abona al final del mes. El cliente que cuenta con un abono de este tipo paga una suma mensual luego de acceder a las prestaciones.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es un APN?</h5>
      <p>
        Las siglas APN vienen de Access Point Name, que en castellano sería Nombre del Punto de Acceso. Se trata de la configuración que le dice a tu móvil por qué camino virtual debe conectarse a Internet, y cada operadora suele tener una ruta diferente.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  },
}
</script>
